import React, { useState, useEffect } from "react";

import { Table } from "react-bootstrap";
import format from "date-fns/format";
import { Redirect } from "react-router";

import Pagination from "react-paginate";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const TableList = (props) => {
  const [values, setValues] = useState("");

  useEffect(() => {
    setValues(props.List);
  }, [props.List]);

  const handlePageChange = (pageNumber) => {
    props.pageChange(pageNumber.selected + 1);
  };
  const [dropdown, setdropdown] = useState({
    value: false,
    id: -1,
  });

  const handleClick = (id) => {
    setdropdown({
      value: id === dropdown.id && true,
      id: id,
    });
  };
  return (
    <div className="table-responsive mx-auto">
      <Table hover className="overflow-auto borderless">
        <thead style={{ borderBottom: "#F5F5F9" }}>
          <tr className="table-head">
            <td className="">Return id</td>
            <td className="">Order id</td>
            <td className="">Item Name</td>
            <td className="">Item Type</td>
            <td className="">Status</td>
            <td className="">Placed On</td>
          </tr>
        </thead>
        <tbody>
          {values !== "" &&
            values.map((return_item) => {
              let id = return_item.id;
              return (
                <tr key={return_item.id} onClick={() => handleClick(id)}>
                  <td className="">{return_item.id}</td>
                  <td className="">{return_item.order_id}</td>
                  <td className="">
                    {return_item.product_name_en
                      ? return_item.product_name_en +
                        " " +
                        return_item.line_item_name_en
                      : return_item.line_item_name_en}
                  </td>
                  <td className="">{return_item.item_type}</td>
                  <td>
                    <div className="status-text">{return_item.status}</div>
                  </td>
                  <td className="">
                    {format(
                      Date.parse(return_item.created_at),
                      "dd MMM, yyy p"
                    )}
                  </td>
                </tr>
              );
            })}
        </tbody>
      </Table>

      {props.pagination?.total_pages && values.length > 0 && (
        <div
          className="d-flex justify-content-center mb-4 w-100"
          style={{ direction: "ltr" }}
        >
          <Pagination
            direction="ltr"
            previousLabel={<FaChevronLeft color="#404553" />}
            nextLabel={<FaChevronRight color="#404553" />}
            pageCount={props.pagination?.total_pages}
            onPageChange={handlePageChange}
            pageRangeDisplayed={2}
            forcePage={parseInt(props?.pagination?.page) - 1}
            containerClassName="pagination"
            pageClassName="ms-3 me-3 ps-3 pe-3 pt-2 pb-2"
            activeClassName={
              "ms-3 me-3 ps-1 pe-1 text-primary border border-primary font-weight-bold rounded bg-white"
            }
            nextClassName="bg-white ps-3 pe-3 pt-2 pb-2"
            previousClassName="bg-white ps-3 pe-3 pt-2 pb-2"
          />
        </div>
      )}
      {dropdown.value && (
        <Redirect
          push
          to={{
            pathname: `/vendor/view-return/${dropdown.id}`,
            state: { name: "view", id: dropdown.id },
          }}
        />
      )}
    </div>
  );
};

export default TableList;
